import React from 'react';
import { withRouter } from 'react-router-dom';
import { Button,Table,Form,Input,Modal,Spin,Col } from 'antd';
import abortAjaxHoc from 'components/abortAjaxHoc';

const FormItem = Form.Item;
const confirm = Modal.confirm;

class RoleManageMember extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            loading:true,
            allMemberLoading:true,
            showEditModel:false,
            addMemberLoading:false,
            list:[],
            roleInfo:{}
        };
        this.selectIds = [];
        this.columns = [{
            title: 'Sub-account',
            dataIndex: 'name',
            key: 'name'
        }, {
            title: 'Nickname',
            dataIndex: 'display_name',
            key: 'display_name'
        }, {
            title: 'Actions',
            dataIndex: 'id',
            key: 'id',
            render:(text, record, index)=>{
                return <Button type="danger" onClick={this.onDelete.bind(this,text,index)}>Delete</Button>
                ;
            }
        }];
        this.allColumns = [{
            title: 'Sub-account',
            dataIndex: 'name',
            key: 'name'
        }, {
            title: 'Nickname',
            dataIndex: 'display_name',
            key: 'display_name'
        }];
        this.id = this.props.match.params.id;
    }

    componentDidMount(){
        const id = this.props.match.params.id;
        const roleInfoReq = this.props.abortableAjax('GET','/roles/'+id).then(res=>{
            this.setState({roleInfo:res.data});
        });
        const memberReq = this.getMemberList(false);
        Promise.all([roleInfoReq,memberReq]).then(()=>{
            this.setState({loading:false});
        }).catch(()=>{
            this.setState({loading:false});
        });
    }

    getMemberList = (isResetLoading=true)=>{
        this.setState({loading:true});
        const memberReq = this.props.abortableAjax('GET','/roles/'+this.id+'/members').then(res=>{
            this.setState({list:res.data});
            if(isResetLoading){
                this.setState({loading:false});
            }
        });
        return memberReq;
    }

    onDelete(id,index){
        confirm({
            title: 'Confirm Deletion',
            content: 'Are you sure you want to delete the role member?',
            onOk:()=>{
                return this.props.abortableAjax('DELETE','/auth/role/'+this.id+'/delete-member/'+id).then(()=>{
                    this.getMemberList();
                });
            },
            onCancel() {}
        });
    }
    
    onAddMember(){
        this.selectIds = [];
        this.setState({showEditModel:true,allMemberLoading:true,memberList:[]});
        this.props.abortableAjax('GET','/auth/member/not-in-role/'+this.props.match.params.id).then(res=>{
            this.setState({memberList:res.data,allMemberLoading:false});
        });
    }
    onOk(){
        if(this.selectIds.length!=0){
            const idArray = this.selectIds.map(item=>{
                return item.id;
            });
            this.setState({addMemberLoading:true});
            this.props.abortableAjax('POST','/auth/role/'+this.id+'/add-member',{
                member_id_list:idArray
            }).then(()=>{
                this.getMemberList();
            }).finally(()=>{
                this.setState({showEditModel:false,addMemberLoading:false});
            });
        }else{
            this.setState({showEditModel:false});
        }
    }
    onCancel(){
        this.setState({showEditModel:false});
    }


    render(){


        const rowSelection = {
            onChange: (selectedRowKeys,selectedRows) => {
                this.selectIds = selectedRows;
            }
        };
        const {loading,roleInfo,list,memberList,allMemberLoading,addMemberLoading} = this.state;
          
        return <div>
            <Spin spinning={loading}>
                <Form onSubmit={this.handleSubmit} style={{'margin':'20px 0'}}>
                    <FormItem
                        label="Role Name"
                        hasFeedback
                    >
                        <Input disabled={true} value={roleInfo.name}/>
                    </FormItem>
                    <FormItem
                        label="Description"
                        hasFeedback
                    >
                        <Input disabled={true}  value={roleInfo.desc}/>
                    </FormItem>
                </Form>
            </Spin>
            <Col offset={5}><Button style={{'marginBottom':'20px'}} type="primary" onClick={this.onAddMember.bind(this)}>Add Member</Button></Col>
            <Col offset={5} span={8}>
                <Table
                    columns={this.columns}
                    rowKey='id'
                    pagination={false}
                    loading={loading}
                    dataSource={list}/>

                <Modal
                    title="Add Role Member"
                    visible={this.state.showEditModel}
                    okButtonProps={{loading:addMemberLoading}}
                    onOk={this.onOk.bind(this)}
                    onCancel={this.onCancel.bind(this)}
                >
                    <Table
                        rowSelection={rowSelection}
                        columns={this.allColumns}
                        rowKey='id'
                        pagination={false}
                        loading={allMemberLoading}
                        dataSource={memberList}/>
                </Modal>
            </Col>
        </div>;
    }
}

export default abortAjaxHoc(withRouter(RoleManageMember));


// WEBPACK FOOTER //
// ./src/pages/roleManagenment/RoleManageMember.js